import { useRouter } from "next/router";
import { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  PackagingDeleteSet,
  PackagingListSet,
} from "../../../api/packagingBasket";
import { failAlert, successAlert } from "../../../common/alert";
import PostCode from "../../../common/postcode";
import Layout from "../../layout/Layout";
import KakaoMap from "../../map/Maptainer";
import * as C from "./CustomizingCart.styles";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../../../redux/action/confirm";
import { priceComma } from "../../../common/splicePrice";
import CartModal from "./CartModal";
import { autoPhoneFormat } from "../../../common/util/checkout-validation";
import { InsertPackaging } from "../../../api/packaging";
import { isLoaded, isLoading } from "../../../redux/action/loading";
import modalOverflowHook from "../../../common/modalOverflowHook";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const CustomizingCart = ({
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
  userInfo,
}) => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const [pickAddress, setPickAddress] = useState("");
  const [userInputs, setUserInputs] = useState({});
  const fileRef = useRef("");
  const [infoFiles, setInfoFiles] = useState([]);
  // 견적 바구니
  const [basketData, setBasketData] = useState([]);
  // 유저 여부
  const isUser = useMemo(() => {
    if (userInfo?.Member?.ukey) {
      return true;
    } else {
      return false;
    }
  }, [userInfo]);

  const userCompany = useMemo(() => {
    if (userInfo?.Company?.Data?.code) {
      return userInfo?.Company?.Data;
    } else {
      return null;
    }
  }, [userInfo]);

  // 견적 상세보기
  const [cartModalOpen, setCartModalOpen] = useState(false);
  const [pickItem, setPickItem] = useState({});
  // 선택 견적
  const [selectedItem, setSelectedItem] = useState([]);
  const [confirmItems, setConfirmItems] = useState([]);

  const modalHook = modalOverflowHook(isOpen || cartModalOpen);

  // 장바구니 리스트 불러오기
  const fetchCustomBasket = async () => {
    isLoading();
    if (router.query.type !== "direct") {
      const body = {
        modes: "ListSet",
      };
      const res = await PackagingListSet(body);
      if (res.Code === "0000") {
        setBasketData(res?.Data?.Rows);
        setSelectedItem(
          new Array(res.Data?.Rows ? res.Data.Rows.length : 1).fill(true)
        );
        setConfirmItems(res.Data?.Rows);
      }
    }
    if (
      router.query.type === "direct" &&
      sessionStorage.getItem("directBasket")
    ) {
      setBasketData(JSON.parse(sessionStorage.getItem("directBasket")));
      setSelectedItem(
        new Array(
          JSON.parse(sessionStorage.getItem("directBasket")).length
        ).fill(true)
      );
      setConfirmItems(JSON.parse(sessionStorage.getItem("directBasket")));
    }
    isLoaded();
  };

  // 장바구니 삭제
  const deleteBasketItem = async (id) => {
    const content = {
      title: "삭제하시겠습니까?",
      actionBtnLabel: "확인",
      actionBtnValid: true,
      cancelBtnLabel: "취소",
      onClose: () => {},
      onAction: async () => {
        if (router.query.type === "direct") {
          successAlert("삭제되었습니다.");
          setBasketData([]);
          sessionStorage.setItem("directBasket", "");
          router.push("/customizing/customizing-products/");
          closeConfirmModal();
          return;
        }
        const body = {
          modes: "DeleteSet",
          id: id,
        };
        const res = await PackagingDeleteSet(body);
        if (res.Code === "0000") {
          successAlert("삭제되었습니다.");
          fetchCustomBasket();
          closeConfirmModal();
        } else {
          failAlert("삭제에 실패했습니다.");
        }
      },
    };
    modifyConfirmModal(content);
    openConfirmModal();
  };

  // 입력 값 적용
  const onChangeUserInputs = (id) => (e) => {
    if (id === "phone" || id === "receipt_num") {
      setUserInputs({
        ...userInputs,
        [id]: e.target.value,
      });
      e.target.value = autoPhoneFormat(e.target.value);
      return;
    }
    if (
      id === "fscYn" ||
      id === "markYn" ||
      id === "forkYn" ||
      id === "designYn"
    ) {
      setUserInputs({
        ...userInputs,
        [id]: e.target.checked,
      });
      return;
    }
    setUserInputs({
      ...userInputs,
      [id]: e.target.value,
    });
  };

  // 견적 추가
  const onClickMore = () => {
    router.push("/customizing/customizing-products");
  };

  // 파일 업로드
  const onClickFileUpLoad = (i) => () => {
    fileRef.current.click();
  };

  const onChangeFiles = (e) => {
    const files = e.target.files;
    if (infoFiles.length >= 3) {
      return failAlert("파일은 최대 3개까지 첨부 가능합니다.");
    }
    Object.values(files).forEach((el) => infoFiles.push(el));
    setInfoFiles([...infoFiles]);
    e.target.value = "";
  };

  // 삭제
  const deletefile = (i) => {
    infoFiles.splice(i, 1);
    setInfoFiles([...infoFiles]);
  };

  // 우편번호 검색
  const onClickHandleModal = () => {
    setIsOpen((prev) => !prev);
  };
  const onCompletePostCode = (postcode) => {
    setPickAddress(postcode.address);
    setUserInputs({
      ...userInputs,
      addressLoad:
        postcode.roadAddress !== ""
          ? postcode.roadAddress
          : postcode.autoRoadAddress,
      addressJibun:
        postcode.jibunAddress !== ""
          ? postcode.jibunAddress
          : postcode.autoJibunAddress,
      addressCode: postcode.zonecode,
    });
    setIsOpen(false);
  };

  // 상세보기
  const openCartModal = (el) => () => {
    setPickItem(el?.options);
    setCartModalOpen(true);
  };

  // 견적 선택
  const selectItem = (i, el) => (e) => {
    const tempArr = [...selectedItem];
    tempArr[i] = e.target.checked;
    setSelectedItem(tempArr);
    if (e.target.checked) {
      const tempArr2 = [...confirmItems];
      tempArr2[i] = el;
      setConfirmItems(tempArr2);
    } else {
      const tempArr2 = [...confirmItems];
      tempArr2[i] = undefined;
      setConfirmItems(tempArr2);
    }
  };

  // 견적 요청
  const confirmCustomizing = async () => {
    if (confirmItems.filter((el) => el !== undefined).length < 1) {
      return failAlert("선택한 견적이 없습니다.");
    }
    if (basketData.length === 0 || basketData == undefined) {
      return failAlert("요청할 견적이 없습니다.");
    }
    const body = {
      modes: "InsertSet",
      usages: userInputs.productInfo ? userInputs.productInfo : "",
      company: userInputs.company || userCompany?.name,
      name: userInputs.name || userInfo?.Member?.name,
      tel: userInputs.phone || userInfo?.Member?.phone,
      email: userInputs.email || userInfo?.Member?.email,
      zipcode: userInputs.addressCode || userCompany?.zipcode,
      doro_addr: userInputs.addressLoad || userCompany?.doro_addr,
      base_addr: userInputs.addressJibun || userCompany?.base_addr,
      detail_addr: userInputs.detail_addr || userCompany?.detail_addr,
      mapx: userInputs.addressGps?.mapx || userCompany?.mapx,
      mapy: userInputs.addressGps?.mapy || userCompany?.mapy,

      content: userInputs?.content ? userInputs.content : "",
      file1: infoFiles[0] ? infoFiles[0] : "",
      file2: infoFiles[1] ? infoFiles[1] : "",
      file3: infoFiles[2] ? infoFiles[2] : "",
      make_item:
        router.query.type === "direct"
          ? JSON.stringify([
              {
                cnt: basketData[0].cnt,
                code: basketData[0].code,
                items: basketData[0].items,
              },
            ])
          : JSON.stringify(confirmItems.filter((el) => el !== undefined)),
      fscYn: userInputs.fscYn === true ? "Y" : "N",
      markYn: userInputs.markYn === true ? "Y" : "N",
      forkYn: userInputs.forkYn === true ? "Y" : "N",
      designYn: userInputs.designYn === true ? "Y" : "N",
    };
    if (
      body.company === "" ||
      body.company === undefined ||
      body.name === "" ||
      body.name === undefined ||
      body.tel === "" ||
      body.tel === undefined ||
      body.email === "" ||
      body.email === undefined
    ) {
      return failAlert("담당자 정보를 입력하세요.");
    }
    if (body.usages === "" || body.usages == undefined) {
      return failAlert("포장 상품 정보를 입력하세요.");
    }
    if (
      body.zipcode === "" ||
      body.zipcode === undefined ||
      body.doro_addr === "" ||
      body.doro_addr === undefined ||
      body.detail_addr === "" ||
      body.detail_addr === undefined
    ) {
      return failAlert("배송지 정보를 입력하세요.");
    }
    isLoading();

    const res = await InsertPackaging(body);
    if (res.Code === "0000") {
      if (router.query.type === "direct") {
        setBasketData([]);
        sessionStorage.setItem("directBasket", "");
        isLoaded();
      } else {
        confirmItems
          .filter((el) => el !== undefined)
          .forEach(async (item) => {
            const body = {
              modes: "DeleteSet",
              id: item.id,
            };
            const res = await PackagingDeleteSet(body);
          });
        isLoaded();
      }
      var UserAgent = navigator.userAgent;
      var widerplanet_device =
        UserAgent.match(
          /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
        ) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null
          ? "mobile"
          : "web";
      var wptg_tagscript_vars = globalThis.wptg_tagscript_vars || [];
      wptg_tagscript_vars.push(function () {
        return {
          wp_hcuid: userInfo?.Member?.id || "",
          ti: "54644",
          ty: "PurchaseComplete",
          device: widerplanet_device,
          items: [
            {
              i: "견적요청 " /*전환 식별 코드  (한글 , 영어 , 번호 , 공백 허용 )*/,
              t: "견적요청 " /*전환명  (한글 , 영어 , 번호 , 공백 허용 )*/,
              p: "1" /*전환가격  (전환 가격이 없을경우 1로 설정 )*/,
              q: "1" /*전환수량  (전환 수량이 고정적으로 1개 이하일 경우 1로 설정 )*/,
            },
          ],
        };
      });
      globalThis.wptg_tagscript?.exec();
      // ENP 맞춤제작
      window.CallMtm({
        productName: "estimate", //광고주 측에서 설정하고 싶은 값(default convType)
        convType: "etc", //etc, join, login
        click: "",
      });
      router.push({
        pathname: "/customizing/complete",
        query: {
          ordernum: res.Data.Ordernum,
          company: body.company,
          name: body.name,
          tel: body.tel,
          email: body.email,
          categories: JSON.stringify(
            confirmItems.filter((el) => {
              if (el !== undefined) return el.code;
            })
          ),
        },
      });
    } else {
      isLoaded();
      failAlert(res.Data?.Msg || "견적 요청 실패");
    }
  };

  useEffect(() => {
    if (isOpen) {
      globalThis.onkeydown = (e) => {
        if (e.code === "Escape") {
          setIsOpen(false);
        }
      };
    }
  }, [isOpen]);

  useEffect(() => {
    fetchCustomBasket();
  }, [router]);

  return (
    <>
      <Layout
        parent={"홈"}
        sub={"맞춤제작"}
        subTitle="견적 바구니"
        pageTitle={SeoMeta.estimateCart.title}
        pageDesc={SeoMeta.estimateCart.description}
        pageKeyword={SeoMeta.estimateCart.keywords}
      >
        <div className="container">
          <C.Container className="row">
            <C.CartWrapper>
              <h2>견적 {router.query.type ? "요청" : "바구니"}</h2>
              <C.CartTableWrapper>
                <span>부가세(VAT별도)</span>
                {/* 견적 목록 */}
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>선택</th>
                        <th>견적 상품</th>
                        <th>수량</th>
                        <th>단가</th>
                        <th>합계</th>
                        <th>삭제</th>
                      </tr>
                    </thead>
                    {isUser || router.query.type === "direct" ? (
                      <tbody>
                        {basketData?.map((el, i) => (
                          <tr key={i}>
                            <td>
                              <div className="custome-checkbox">
                                <input
                                  type="checkbox"
                                  id={`${el.id}`}
                                  className="form-check-input"
                                  value={el.id ? el.id : ""}
                                  onChange={selectItem(i, el)}
                                  checked={selectedItem[i]}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`${el.id}`}
                                  style={{
                                    textTransform: "capitalize",
                                  }}
                                />
                              </div>
                            </td>
                            <td>
                              <div>
                                <img
                                  src={
                                    el.images && el.images[0]
                                      ? el.images[0]
                                      : el.image
                                  }
                                  className="mr-10"
                                />

                                <div>{el.name}</div>
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={openCartModal(el)}
                                >
                                  상세
                                </button>
                              </div>
                            </td>
                            <td>{priceComma(el.cnt)}</td>
                            {router.query.type === "direct" ? (
                              <td>
                                {el.unit == "0"
                                  ? "24시간 이내 견적"
                                  : priceComma(el.unit) + "원"}
                              </td>
                            ) : (
                              <td>
                                {el.price == "0"
                                  ? "24시간 이내 견적"
                                  : priceComma(el.price) + "원"}
                              </td>
                            )}
                            {router.query.type === "direct" ? (
                              <td>
                                {el.unit == "0"
                                  ? "24시간 이내 견적"
                                  : priceComma(
                                      Number(el.cnt) * Number(el.unit)
                                    ) + "원"}
                              </td>
                            ) : (
                              <td>
                                {el.price == "0"
                                  ? "24시간 이내 견적"
                                  : priceComma(
                                      Number(el.cnt) * Number(el.price)
                                    ) + "원"}
                              </td>
                            )}
                            <td>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => deleteBasketItem(el.id)}
                              >
                                삭제
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan={6}>
                            로그인 시 담은 견적을 확인하실 수 있습니다.
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </>
                {/* 모바일 견적 목록 */}
                {isUser || router.query.type === "direct" ? (
                  <>
                    {basketData?.map((el, i) => (
                      <C.CartProductsMobile key={i}>
                        {basketData?.length <= 0 && "견적이 없습니다"}
                        <div className="custome-checkbox">
                          <input
                            type="checkbox"
                            id={`${el.id}`}
                            className="form-check-input"
                            value={el.id ? el.id : ""}
                            onChange={selectItem(i, el)}
                            checked={selectedItem[i]}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${el.id}`}
                            style={{
                              textTransform: "capitalize",
                            }}
                          />
                        </div>
                        <C.ProductMobileImg>
                          <img src={el.image} alt="" className="mr-10" />
                        </C.ProductMobileImg>
                        <C.ProductMobileInfo>
                          <h6>{el.name}</h6>
                          <span> 수량 : {priceComma(el.cnt)}개</span>
                          {router.query.type === "direct" ? (
                            <span>
                              단가 :{" "}
                              {el.unit == "0"
                                ? "24시간 이내 견적"
                                : priceComma(el.unit) + "원"}
                            </span>
                          ) : (
                            <span>
                              단가 :{" "}
                              {el.price == "0"
                                ? "24시간 이내 견적"
                                : priceComma(el.price) + "원"}
                            </span>
                          )}
                          <div>
                            {router.query.type === "direct" ? (
                              <span>
                                합계 :{" "}
                                {el.unit == "0"
                                  ? "24시간 이내 견적"
                                  : priceComma(
                                      Number(el.cnt) * Number(el.unit)
                                    ) + "원"}
                              </span>
                            ) : (
                              <span>
                                합계 :{" "}
                                {el.price == "0"
                                  ? "24시간 이내 견적"
                                  : priceComma(
                                      Number(el.cnt) * Number(el.price)
                                    ) + "원"}
                              </span>
                            )}
                            <div className="btn_wrapper">
                              <button
                                className="btn btn-sm btn-primary mt-5"
                                onClick={openCartModal(el)}
                              >
                                상세
                              </button>
                              <button
                                className="btn btn-sm btn-danger ml-10 mt-5"
                                onClick={() => deleteBasketItem(el.id)}
                              >
                                삭제
                              </button>
                            </div>
                          </div>
                        </C.ProductMobileInfo>
                      </C.CartProductsMobile>
                    ))}
                  </>
                ) : (
                  <div>로그인 시 담은 견적을 확인하실 수 있습니다.</div>
                )}
              </C.CartTableWrapper>
              {(isUser || router.query.type === "direct") && (
                <>
                  <C.InfoWrapper>
                    <C.InfoBox>
                      <div className="title">
                        <h5>
                          주문인 정보{" "}
                          <span
                            className="input-option"
                            style={{ color: "red" }}
                          >
                            (필수)
                          </span>
                        </h5>
                      </div>
                      <C.FormInputRow>
                        <C.FormInputBasicSpan>업체명</C.FormInputBasicSpan>
                        <C.FormInputBasicInput
                          type={"text"}
                          placeholder="업체명"
                          onChange={onChangeUserInputs("company")}
                          defaultValue={userCompany?.name || ""}
                        />
                      </C.FormInputRow>
                      <C.FormInputRow>
                        <C.FormInputBasicSpan>담당자</C.FormInputBasicSpan>
                        <C.FormInputBasicInput
                          type={"text"}
                          placeholder="담당자"
                          onChange={onChangeUserInputs("name")}
                          defaultValue={userInfo?.Member?.name || ""}
                        />
                      </C.FormInputRow>
                      <C.FormInputRow>
                        <C.FormInputBasicSpan>
                          담당자 연락처
                        </C.FormInputBasicSpan>
                        <C.FormInputBasicInput
                          type={"text"}
                          placeholder="-를 제외한 숫자만"
                          onChange={onChangeUserInputs("phone")}
                          defaultValue={userInfo?.Member?.phone || ""}
                          maxLength={13}
                        />
                      </C.FormInputRow>
                      <C.FormInputRow>
                        <C.FormInputBasicSpan>
                          담당자 이메일
                        </C.FormInputBasicSpan>
                        <C.FormInputBasicInput
                          type={"text"}
                          placeholder="이메일"
                          onChange={onChangeUserInputs("email")}
                          defaultValue={userInfo?.Member?.email || ""}
                        />
                      </C.FormInputRow>
                      <div className="title mt-25">
                        <h5>
                          배송지 정보{" "}
                          <span
                            className="input-option"
                            style={{ color: "red" }}
                          >
                            (필수)
                          </span>
                        </h5>
                      </div>
                      <C.AddressSearch>
                        <C.FormInputBasicSpan>주소</C.FormInputBasicSpan>
                        <div>
                          <C.FormBasicBtn
                            type="button"
                            onClick={onClickHandleModal}
                          >
                            주소검색
                          </C.FormBasicBtn>
                          <input
                            disabled
                            value={
                              userInputs?.addressCode ||
                              userCompany?.zipcode ||
                              ""
                            }
                            readOnly
                          />
                        </div>
                      </C.AddressSearch>
                      <C.FormInputRow>
                        <C.FormInputBasicSpan></C.FormInputBasicSpan>
                        <C.FormInputBasicInput
                          disabled
                          address={true}
                          readOnly
                          value={pickAddress || userCompany?.doro_addr || ""}
                        />
                      </C.FormInputRow>
                      <C.FormInputRow>
                        <C.FormInputBasicSpan></C.FormInputBasicSpan>
                        <C.FormInputBasicInput
                          placeholder="상세주소 입력"
                          address={true}
                          value={
                            userInputs?.detail_addr ||
                            userCompany?.detail_addr ||
                            ""
                          }
                          onChange={onChangeUserInputs("detail_addr")}
                        />
                      </C.FormInputRow>
                      <C.FormInputLargeRow>
                        <C.FormInputLargeSpan>
                          <div className="env-policy">
                            <label
                              htmlFor={`forkYn`}
                              style={{ cursor: "pointer" }}
                            >
                              • 하차지 지게차 보유
                              {/* <span className="input-option">(선택)</span> */}
                            </label>
                            <div className="custome-checkbox">
                              <input
                                type="checkbox"
                                id={`forkYn`}
                                className="form-check-input"
                                onChange={onChangeUserInputs("forkYn")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`forkYn`}
                                style={{
                                  textTransform: "capitalize",
                                }}
                              />
                            </div>
                          </div>
                        </C.FormInputLargeSpan>
                      </C.FormInputLargeRow>
                    </C.InfoBox>
                    <C.InfoBox>
                      <div className="title">
                        <h5>포장 상품 정보</h5>
                      </div>
                      <C.FormInputLargeRow>
                        <C.FormInputLargeSpan>
                          <span>
                            포장하시는 상품 정보를 모두 입력해주세요.
                            <span
                              className="input-option"
                              style={{ color: "red" }}
                            >
                              (필수)
                            </span>
                          </span>
                          <span className="example">{`예시) 4kg / 화장품`}</span>
                        </C.FormInputLargeSpan>
                        <C.FormInputBasicInput
                          placeholder="상품 정보 입력"
                          full
                          onChange={onChangeUserInputs("productInfo")}
                        />
                      </C.FormInputLargeRow>
                      <C.FormInputLargeRow>
                        <C.FormInputLargeSpan>
                          <span>
                            파일 업로드 예) 상품, 인쇄, 참고 이미지
                            <span className="input-option"></span>
                          </span>
                        </C.FormInputLargeSpan>
                        <C.FileUploadWrapper>
                          <C.FileUploadLabel onClick={onClickFileUpLoad()}>
                            파일 선택 <br />
                            (최대 3개)
                          </C.FileUploadLabel>
                          <input
                            name="subject"
                            placeholder="참고 파일"
                            type="file"
                            multiple
                            // ref={(ref) => (fileRef.current[0] = ref)}
                            ref={fileRef}
                            onChange={onChangeFiles}
                          />
                          <ul>
                            {infoFiles &&
                              infoFiles.length > 0 &&
                              infoFiles.map((file, i) => (
                                <li key={i}>
                                  <span className="mr-15">{`${i + 1}. ${
                                    file.name
                                  }`}</span>
                                  <span
                                    className="delete_file_btn"
                                    onClick={() => deletefile(i)}
                                  >
                                    X
                                  </span>
                                </li>
                              ))}
                          </ul>
                        </C.FileUploadWrapper>
                      </C.FormInputLargeRow>
                      <C.FormInputLargeRow>
                        <div className="title mt-25">
                          <h5>선택 사항</h5>
                        </div>
                        <C.FormInputLargeSpan>
                          <div className="env-policy">
                            <label htmlFor={`fscYn`}>• FSC 인증</label>
                            <div className="custome-checkbox">
                              <input
                                type="checkbox"
                                id={`fscYn`}
                                className="form-check-input"
                                onChange={onChangeUserInputs("fscYn")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`fscYn`}
                                style={{
                                  textTransform: "capitalize",
                                }}
                              />
                            </div>
                            <label htmlFor={`markYn`}>
                              • 스텝포넷제로 마크
                            </label>
                            <div className="custome-checkbox">
                              <input
                                type="checkbox"
                                id={`markYn`}
                                className="form-check-input"
                                onChange={onChangeUserInputs("markYn")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`markYn`}
                                style={{
                                  textTransform: "capitalize",
                                }}
                              />
                            </div>
                            <label htmlFor={`designYn`}>• 디자인 서비스</label>
                            <div className="custome-checkbox">
                              <input
                                type="checkbox"
                                id={`designYn`}
                                className="form-check-input"
                                onChange={onChangeUserInputs("designYn")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`designYn`}
                                style={{
                                  textTransform: "capitalize",
                                }}
                              />
                            </div>
                          </div>
                        </C.FormInputLargeSpan>
                      </C.FormInputLargeRow>
                      <C.FormInputLargeRow>
                        <div className="title">
                          <h5>요청 사항 </h5>
                        </div>
                        <textarea
                          placeholder={"견적시 요청할 내용을 작성해주세요."}
                          onChange={onChangeUserInputs("content")}
                        />
                      </C.FormInputLargeRow>
                    </C.InfoBox>
                  </C.InfoWrapper>
                  <C.CartBtnWrapper>
                    {router.query.type !== "direct" && (
                      <button
                        className="btn btn-md btn-secondary"
                        onClick={onClickMore}
                      >
                        견적 추가
                      </button>
                    )}
                    <button className="btn btn-md" onClick={confirmCustomizing}>
                      {router.query.type === "direct" ? "" : "선택"} 견적 요청
                    </button>
                  </C.CartBtnWrapper>
                </>
              )}
            </C.CartWrapper>
          </C.Container>
        </div>
      </Layout>
      {isOpen && (
        <PostCode
          onClickHandleModal={onClickHandleModal}
          onCompletePostCode={onCompletePostCode}
        />
      )}
      {pickAddress && (
        <div style={{ display: "hidden" }}>
          <KakaoMap
            userInputs={userInputs}
            setUserInputs={setUserInputs}
            address={pickAddress}
          />
        </div>
      )}
      {cartModalOpen && (
        <CartModal
          cartModalOpen={cartModalOpen}
          setCartModalOpen={setCartModalOpen}
          pickItem={pickItem}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});

const mapDispatchToProps = {
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomizingCart);
